import { axiosInstance } from "./axios";

export interface PlayerSummaryResponse {
    id: number;
    playerId: number;
    tournamentId: number;
    teamId: number;
    summary: string;
    model: string;
    tokensUsed: number;
    createdAt: string;
    updatedAt?: string;
    wasGenerated: boolean;
}


export const playerSummaryApi = {
    // Generate a new player summary
    generateSummary: async (playerId: number, tournamentId: number, teamId: number): Promise<PlayerSummaryResponse> => {
        const response = await axiosInstance.post<PlayerSummaryResponse>(
            `/players/${playerId}/tournaments/${tournamentId}/teams/${teamId}/summary`
        );
        return response.data;
    },

    // Regenerate existing player summary
    regenerateSummary: async (playerId: number, tournamentId: number, teamId: number): Promise<PlayerSummaryResponse> => {
        const response = await axiosInstance.put<PlayerSummaryResponse>(
            `/players/${playerId}/tournaments/${tournamentId}/teams/${teamId}/summary/regenerate`
        );
        return response.data;
    },

    // Get existing player summary
    getSummary: async (playerId: number, tournamentId: number, teamId: number, forceRegenerate: boolean = false): Promise<PlayerSummaryResponse> => {
        const response = await axiosInstance.get<PlayerSummaryResponse>(
            `/players/${playerId}/tournaments/${tournamentId}/teams/${teamId}/summary?forceRegenerate=${forceRegenerate}`
        );
        return response.data;
    },
};
